'use strict';

// Dependencies
var angular = window.angular = require('../../bower_components/angular');
var jwtDecode = require('jwt-decode');

var Raven = require('../../bower_components/raven-js/dist/raven.min.js');
var RavenAngularPlugin = require('../../bower_components/raven-js/dist/plugins/angular.js');
window.Raven = Raven;
Raven
    .config(window.config.sentryDsn, {release: window.config.release, tags: {clusterName: window.config.clusterName}})
    .addPlugin(RavenAngularPlugin, angular)
    .install();

require('../../bower_components/angular-animate/angular-animate');
require('../../bower_components/angular-ui-router/release/angular-ui-router');
require('../../bower_components/angular-bootstrap/ui-bootstrap-tpls');
require('../../bower_components/angular-gettext/dist/angular-gettext');
require('../../bower_components/angular-ui-router-tabs/src/ui-router-tabs');
require('../../bower_components/angular-local-storage/dist/angular-local-storage');
require('../../bower_components/angular-mask/dist/ngMask');
require('../../bower_components/angular-scroll/angular-scroll');
require('../../bower_components/angular-sanitize/angular-sanitize');
require('../../bower_components/angular-utf8-base64/angular-utf8-base64');
require('../../bower_components/ngSmoothScroll/dist/angular-smooth-scroll.min');
require('../../bower_components/ez-ng/dist/ez-ng');
require('../../bower_components/angular-hotkeys/build/hotkeys');
require('../../bower_components/angular-ui-tour/dist/angular-ui-tour');
require('../../bower_components/angular-avatar/dist/angular-avatar');
window.jQuery = require('../../bower_components/jquery/dist/jquery');
require('../../bower_components/pnotify/pnotify.core.js');
require('../../bower_components/pnotify/pnotify.confirm.js');
require('../../bower_components/pnotify/pnotify.buttons.js');
window.markdownit = require('markdown-it');
require('angular-markdown-it');
window.helpers = require('./helpers');
require('./components/common/common.module');
require('./components/verificationMethods/verificationMethods.module');
window.uuid = require('../../bower_components/uuid/uuid');
var app = angular.module('sa.ParentPortal', [
    'sa.kws.parents.common',
    'sa.kws.parents.verificationMethods',
    'templates',
    'ui.router',
    'ui.bootstrap',
    'ui.router.tabs',
    'gettext',
    'LocalStorageModule',
    'ngMask',
    'duScroll',
    'ngSanitize',
    'bm.uiTour',
    'ab-base64',
    'ngAvatar',
    'mdMarkdownIt'
]); // Angular App

// Services
app.service('networkService', require('./services/networkService'));
app.service('notification', require('./services/notification'));
app.service('permissionsService', require('./services/permissionsService'));
app.service('featureInfo', require('./services/featureInfo'));
app.service('token', require('./services/token'));
app.service('language', require('./services/language'));
app.service('branding', require('./services/branding'));
app.service('events', require('./services/events'));
app.service('oauthProvider', require('./services/oauthProvider'));
app.service('oauthProviderList', require('./services/oauthProviderList'));
app.service('amplitude', require('./services/amplitude'));


//constants about languages
var languages;
try {
    languages = JSON.parse(window.config.languages);
    if (Object.keys(languages).length === 0) {
        throw new Error('Should be defined at least 1 language');
    }
} catch (e) {
    if (window.config.languages) {
        console.error('Unable to parse languages enviroment variable');
    }
    // TODO: Add dutch back in again once env vars are working properly
    // 'ascii' codec can't encode characters in position 28-29: ordinal not in range(128)
    languages = {
        'en': 'English',
        'fr': 'Français',
        'it': 'Italiano',
        'es': 'Español',
        'de': 'Deutsch',
        'pt': 'Português',
        'ja': '日本語',
        'ko': '한국어',
        'ru': 'русский',
        'zh-tw': '國語',
        'zh-cn': '中文',
        'th': 'ไทย',
        'tr': 'Türkçe',
    };
}
app.constant('LANGUAGES', languages);

app.constant('DEFAULT_LANGUAGE', Object.keys(languages)[0]);

// Directives
app.directive('navbarScroll', require('./directives/navbarScroll'));
app.directive('match', require('./directives/match'));
app.directive('datepickerPopup', require('./directives/datepickerPopup'));
app.directive('placeholder', require('./directives/placeholder'));
app.directive('popoverToggle', require('./directives/popoverToggle'));
app.directive('popoverClose', require('./directives/popoverClose'));
app.directive('enter', require('./directives/enter'));
app.directive('childInfoBox', require('./directives/childInfoBox'));
app.directive('appInfoBox', require('./directives/appInfoBox'));
app.directive('monsterAvatar', require('./directives/monsterAvatar'));
app.directive('featureOverview', require('./directives/featureOverview'));
app.directive('enableDisableToggle', require('./directives/enableDisableToggle'));
app.directive('saveCancelButtons', require('./directives/saveCancelButtons'));
app.directive('editChildProfileForm', require('./directives/editChildProfileForm'));
app.directive('appPermissionAccessTooltip', require('./directives/appPermissionAccessTooltip'));
app.directive('tourInit', require('./directives/tourInit'));
app.directive('onFinishRender', require('./directives/onFinishRender'));
app.directive('onTextOverflow', require('./directives/onTextOverflow'));
app.directive('stripeElementDecorator', require('./directives/stripeElementDecorator'));
app.component('stripeElement', require('./directives/stripeElement'));
app.component('saCheckboxInput', require('./directives/saCheckboxInput.component'));

//Filters
app.filter('childName', require('./filters/childName'));
app.filter('commaSeparated', require('./filters/commaSeparated'));
app.filter('countryFromIsoCode', require('./filters/countryFromIsoCode'));
app.filter('kwsTranslate', require('./filters/kwsTranslate'));
app.filter('millSecondsToTimeString', require('./filters/millSecondsToTimeString'));
app.filter('absoluteURL', require('./filters/absoluteURL'));

// Factories
app.factory('ieCacheFix', require('./factories/ieCacheFix'));

// Configuration
/* @ngInject */
app.config(function ($stateProvider, $urlRouterProvider, $locationProvider) {
        // Application routes
        $stateProvider
            .state('oauthCallback', {
                url: '/oauth-callback?{code:string}&{state:string}',
                templateUrl: 'templates/oauthCallback.html',
                controller: require('./controllers/oauthCallback'),
                controllerAs: 'oauthCallbackController',
            })
            .state('root.authenticated', {
                controller: require('./controllers/root.authenticated'),
                controllerAs: 'authenticatedController',
                templateUrl: 'templates/root.authenticated.html',
                params: {
                    clientId: {
                        squash: true
                    },
                    redirectUri: {
                        squash: true
                    }
                },
                resolve: {
                    childrenAccess: function($state, networkService, events, parent){
                        if (!parent) {
                          $state.go('root.anonymous.box.login');
                          throw new Error('Not authenticated!');
                        }
                        return networkService.getChildren()
                            .then(function (response) {
                                angular.forEach(response.data, function (data) {
                                    data.appNames = [];
                                    angular.forEach(data.apps, function (appData) {
                                        var sortedData = {
                                            link: appData.app.domain,
                                            iconUrl: appData.app.iconUrl,
                                            logoUrl: appData.app.logoUrl,
                                            description: appData.app.description,
                                            activeFeatures: [],
                                            verificationRequired: appData.app.verificationRequired
                                        };
                                        angular.extend(appData, sortedData);
                                        data.appNames.push(sortedData.displayName);
                                    });
                                });
                                events.setChildren(response.data);
                                return response.data;
                            }).catch(function() {
                                events.setChildren([]);
                                return [];
                            });
                    },
                    pendingChildren: function(childrenAccess){
                        var pendingChildren = [];
                        for (var i in childrenAccess) {
                            if (childrenAccess[i].status === null) {
                                pendingChildren.push(childrenAccess[i]);
                            }
                        }
                        return pendingChildren;
                    },
                }
            })
            .state('root.authenticated.parentInfo', {
                url:'/parent-info?clientId',
                controller: require('./controllers/root.authenticated.parentInfo'),
                controllerAs: 'parentInfoController',
                templateUrl: 'templates/root.authenticated.parentInfo.html',
                params: {
                    clientId: {
                        squash: true
                    }
                },
            })
            .state('root.authenticated.myChildren', {
                url:'/my-children?{childId:int}&{clientId:string}',
                controller: require('./controllers/root.authenticated.myChildren'),
                controllerAs: 'myChildrenController',
                templateUrl: 'templates/root.authenticated.myChildren.html',
                params: {
                    childId: { squash: true },
                    clientId: { squash: true },
                },
            })
            .state('root.authenticated.newChild', {
                url:'/new-child?{childId:int}&{clientId:string}',
                controller: require('./controllers/root.authenticated.newChild'),
                controllerAs: 'newChildController',
                templateUrl: 'templates/root.authenticated.newChild.html',
                params: {
                    childId: { squash: true },
                    clientId: { squash: true },
                },
            })
            .state('root.authenticated.myChild', {
                url:'/my-child/{childId:int}',
                params: {
                    openAppModal: null
                },
                controller: require('./controllers/root.authenticated.myChild'),
                controllerAs: 'myChildController',
                templateUrl: 'templates/root.authenticated.myChild.html',
                onEnter: function ($window) {
                    $window.scrollTo(0,0); // Manualy scrolling to page top, autoscroll is not working on this view
                }
            })
            .state('root.anonymous', {
                abstract: true,
                templateUrl: 'templates/root.anonymous.html',
                controller: require('./controllers/root.anonymous'),
                controllerAs: 'anonymousController',
            })
            .state('root.anonymous.privacy', {
                url: '/privacy',
                templateUrl: 'templates/root.anonymous.privacy.html',
                controller: function ($window) {
                  setTimeout(function() {
                    $window.open('https://www.kidswebservices.com/privacy-policy', '_self');
                  }, 1000);
                }
            })
            .state('root.anonymous.terms', {
                url: '/terms-of-use',
                templateUrl: 'templates/root.anonymous.terms.html',
                controller: function ($window) {
                  setTimeout(function() {
                    $window.open('https://www.superawesome.com/kws-terms-of-use', '_self');
                  }, 1000);
                }
            })
            .state('root.anonymous.faq', {
                url: '/faq',
                controller: require('./controllers/root.anonymous.faq'),
                controllerAs: 'faqController',
                templateUrl: 'templates/root.anonymous.faq.html'
            })
            .state('root.anonymous.about', {
                url:'/about',
                controller: require('./controllers/root.anonymous.about'),
                controllerAs: 'aboutController',
                templateUrl: 'templates/root.anonymous.about.html'
            })
            .state('root.anonymous.saclub', {
                url: '/club',
                templateUrl: 'templates/root.anonymous.saclub.html'
            })
            .state('root.anonymous.box.validateEmail', {
                url:'/validate-email/:email/:token/{branding}?redirectUri&skipPassword&permissions&childId&clientId&{oauthProviderError:string}',
                controller: require('./controllers/root.anonymous.box.validateEmail'),
                controllerAs: '$ctrl',
                templateUrl: 'templates/root.anonymous.box.validateEmail.html',
                params : {
                    clientId: { squash: true },
                    redirectUri: { squash: true },
                    skipPassword: { squash: true },
                    permissions: { squash: true },
                },
                resolve: {
                    validateEmailParentId: function($state, networkService, $stateParams, notification, gettextCatalog) {
                        return networkService.validateEmail({
                            dryRun: true,
                            email: $stateParams.email,
                            token: $stateParams.token
                        }).then(function(resp){
                            return resp.data.id;
                        }).catch(function(err){
                            notification.error({
                                title: gettextCatalog.getString('Error'),
                                description: gettextCatalog.getString('The token is invalid'),
                            });
                            $state.go('root.anonymous.box.login');
                            // return null;
                            throw err;
                        });
                    }
                }
            })
            .state('root.anonymous.box.forgottenPassword', {
                url:'/forgotten-password?{clientId:string}',
                controller: require('./controllers/root.anonymous.box.forgottenPassword'),
                controllerAs: 'forgottenPasswordController',
                templateUrl: 'templates/root.anonymous.box.forgottenPassword.html'
            })
            .state('root.anonymous.box.resetPass', {
                url:'/reset-password/:email/:token',
                controller: require('./controllers/root.anonymous.box.resetPass'),
                controllerAs: 'resetPassController',
                templateUrl: 'templates/root.anonymous.box.resetPass.html'
            });

        if(window.config.enableMagicLinks){
          $stateProvider.state('root', {
            abstract: true,
            url: '/{local:[a-z]{2}(?:-[aA-zZ]{2})?}?{magicToken:string}',
            controller: require('./controllers/root'),
            controllerAs: 'rootController',
            templateUrl: 'templates/root.html',
            params:{
              local:'en',
              utm_source: null, // jshint ignore:line
              u: null
            },
            resolve: {
              config: function($stateParams, $rootScope, language) {
                // Save current language
                $stateParams.local = $stateParams.local.toLowerCase();
                // just in case somebody manually wrote the locale dirently in the URL.
                var local = 
                  (
                    Object.keys(languages).indexOf($stateParams.local) >= 0 ||
                    Object.keys(languages).indexOf($stateParams.local.substring(0, 2)) >= 0
                  ) ? $stateParams.local : 'en';
                language.save(local);
                $rootScope.disableHomePages = window.config.disableHomePages && window.config.disableHomePages !== 'false';
                $rootScope.local = local;
                return window.config;
              },
              magicLinkLogin: function($stateParams, $state, $timeout, networkService, $location, token) {
                /* Changing state in a timeout will put the state change at the end of the queue and trigger it after the 'resolve'
                function throws the error. Otherwise, changing state does not work in the resolve and the original state will still be loaded. */
                function changeState(state, params) {
                  $location.search('magicToken', null);
                  $timeout(function(){
                    $state.go(state, params);
                  }, 0);
                  throw new Error('bad magic token');
                }
                if (!$stateParams.magicToken) {
                  return { userWasSignedInWithMagicToken: false };
                }
                var tokenData;
                try {
                  tokenData = jwtDecode($stateParams.magicToken);
                } catch(err) {
                  console.error('Error decoding token:', err);
                  changeState('root.anonymous.box.tokenInvalidError', {});
                }
                if (tokenData.type !== 'login') {
                  return { userWasSignedInWithMagicToken: false };
                }
                return networkService.checkMagicToken($stateParams.magicToken)
                  .then(function(resp) {
                    // User is logged in
                    token.set(resp.data.token);
                    $location.search('magicToken', null);
                    return { userWasSignedInWithMagicToken: true };
                  })
                  .catch(function(err) {
                    if (!err.data) {
                      console.error('Unexpected error with token:', err);
                      return changeState('root.anonymous.box.tokenInvalidError', {});
                    }
                    switch (err.data.errorMessage) {
                      case 'jwt expired':
                        changeState('root.anonymous.box.tokenExpiredError', { token: $stateParams.magicToken });
                        break;
                      case 'jwt malformed':
                      default:
                        changeState('root.anonymous.box.tokenInvalidError', {});
                    }
                  });
              },
              // Inject magicLinkToken so it resolves the token stuff first and logs the user in if necessary
              parent: function(networkService, $rootScope, magicLinkLogin, amplitude){
                return networkService.getCurrentParent()
                  .then(function(response){
                    $rootScope.isParentVerified = response.data ? !!response.data.isVerified : false;
                    var parent = response.data;
                    // Send login success event here; could not do it in the other resolve as we didn't have the parent email yet
                    if (magicLinkLogin.userWasSignedInWithMagicToken) {
                      amplitude.setUserId(parent.email);
                      amplitude.logEvent('login_successful');
                    }
                    return response.data;
                  })
                  .catch(function() {
                    return null;
                  });
              },
              clusterConfig: function ($rootScope, networkService, branding) {
                return networkService.getConfig()
                  .then(function(resp) {
                    branding.setClusterBranding(resp.branding);
                    $rootScope.hideLogin = resp.hideLogin;
                    $rootScope.country = resp.country;
                    $rootScope.verificationRequired = resp.verificationRequired;
                    $rootScope.ESRBLogoUrl = resp.ESRBLogoUrl;
                    return resp;
                  });
              },
              clusterBranding: function(clusterConfig) {
                return clusterConfig.branding;
              },
            }
          })
            .state('root.anonymous.box', {
              abstract: true,
              url: '?{magicToken:string}',
              controller: require('./controllers/root.anonymous.box'),
              controllerAs: 'anonBoxController',
              params: {
                magicToken: { squash: true },
              },
              templateUrl: function() {
                if (window.config.disableHomePages && window.config.disableHomePages !== 'false') {
                  return 'templates/root.anonymous.box_simple.html';
                }
                return 'templates/root.anonymous.box.html';
              },
              resolve: {
                checkForRedirect: function($location, $stateParams) {
                  if (window.config.enableRedirectToNewApp === 'true' && $stateParams.magicToken) {
                    try {
                      var tokenData = jwtDecode($stateParams.magicToken);
                      var allowedTokenTypes = ['request_permission', 'automatic_account', 'review_permissions'];
                      if (!allowedTokenTypes.includes(tokenData.type)) {
                        // Token not valid for transactional flows. Don't redirect.
                        return;
                      }
                      var parentId = tokenData.parentId;

                      if (parentId) {
                        var redirectionUrl = '/app/' + $stateParams.local + '/' + 'action' + '/' + '?token=' + $stateParams.magicToken;
                        window.location.href = redirectionUrl;
                        return;
                      }
                    } catch(err) {
                      console.error('Error decoding token: ', err);
                    }

                    $location.search('magicToken', null);
                  }
                },
              }
            })
            .state('root.anonymous.box.login', {
                url:'/login?{email:string}&{childId:int}&{clientId:string}&{oauthProviderError:string}',
                controller: require('./controllers/root.anonymous.box.magiclogin'),
                controllerAs: 'loginController',
                templateUrl: 'templates/root.anonymous.box.magiclogin.html',
                resolve: {
                    redirect: function($timeout, $state, $stateParams, parent) {
                        if (!parent) {
                            return;
                        }
                        // If already signed in, redirect to the myChildren page before loading the controller, to avoid a flash of the login page first
                        var childParams = {
                            childId: $stateParams.childId,
                            clientId: $stateParams.clientId
                        };
                        // Use $timout to push the state change to the end of the queue so it'll happen after the error is thrown and the route doesn't resolve (otherwise the redirect won't work)
                        $timeout(function(){
                            $state.go('root.authenticated.myChildren', childParams, { reload: true });
                        }, 0);
                        throw new Error('already logged in');
                    },
                },
                params : {
                    email: null,
                    childId: { squash: true },
                    clientId: { squash: true },
                },
            })
            .state('root.anonymous.box.tokenExpiredError', {
              url:'/token-expired/{token:string}',
              controller: require('./controllers/root.anonymous.box.tokenExpiredError'),
              controllerAs: '$ctrl',
              templateUrl: 'templates/root.anonymous.box.tokenExpiredError.html',
              params : {
                token: null,
              },
            })
            .state('root.anonymous.box.tokenInvalidError', {
              url:'/token-invalid',
              controller: require('./controllers/root.anonymous.box.tokenInvalidError'),
              controllerAs: '$ctrl',
              templateUrl: 'templates/root.anonymous.box.tokenInvalidError.html',
            });
        }else{
          $stateProvider.state('root', {
            abstract: true,
            url: '/{local:[a-z]{2}(?:-[aA-zZ]{2})?}?utm_source&u',
            controller: require('./controllers/root'),
            controllerAs: 'rootController',
            templateUrl: 'templates/root.html',
            params: {
              local: 'en',
              utm_source: null, // jshint ignore:line
              u: null
            },
            resolve: {
              config: function ($stateParams, $rootScope, language) {
                // Save current language
                $stateParams.local = $stateParams.local.toLowerCase();
                // just in case somebody manually wrote the locale dirently in the URL.
                var local = (
                  Object.keys(languages).indexOf($stateParams.local) >= 0 ||
                  Object.keys(languages).indexOf($stateParams.local.substring(0, 2)) >= 0
                ) ? $stateParams.local : 'en';
                language.save(local);
                $rootScope.disableHomePages = window.config.disableHomePages && window.config.disableHomePages !== 'false';
                $rootScope.local = local;
                return window.config;
              },
              parent: function (networkService, $rootScope) {
                return networkService.getCurrentParent()
                  .then(function (response) {
                    $rootScope.isParentVerified = response.data ? !!response.data.isVerified : false;
                    return response.data;
                  })
                  .catch(function () {
                    return null;
                  });
              },
              clusterConfig: function ($rootScope, networkService, branding) {
                return networkService.getConfig()
                  .then(function (resp) {
                    branding.setClusterBranding(resp.branding);
                    $rootScope.hideLogin = resp.hideLogin;
                    $rootScope.country = resp.country;
                    $rootScope.verificationRequired = resp.verificationRequired;
                    $rootScope.ESRBLogoUrl = resp.ESRBLogoUrl;
                    return resp;
                  });
              },
              clusterBranding: function (clusterConfig) {
                return clusterConfig.branding;
              }
            }
          })
            .state('root.anonymous.box', {
              abstract: true,
              url: '?{magicToken:string}',
              controller: require('./controllers/root.anonymous.box'),
              controllerAs: 'anonBoxController',
              params: {
                magicToken: { squash: true },
              },
              templateUrl: function() {
                if (window.config.disableHomePages && window.config.disableHomePages !== 'false') {
                  return 'templates/root.anonymous.box_simple.html';
                }
                return 'templates/root.anonymous.box.html';
              },
              resolve: {
                checkForRedirect: function($location, $stateParams) {
                  if (window.config.enableRedirectToNewApp === 'true' && $stateParams.magicToken) {
                    try {
                      var parentId = jwtDecode($stateParams.magicToken).parentId;

                      if (parentId) {
                        var redirectionUrl = '/app/' + $stateParams.local + '/' + 'action' + '/' + '?token=' + $stateParams.magicToken;
                        window.location.href = redirectionUrl;
                        return;
                      }
                    } catch(err) {
                      console.error('Error decoding token: ', err);
                    }

                    $location.search('magicToken', null);
                  }
                },
              }
            })
            .state('root.anonymous.box.login', {
                url: '/login?{email:string}&{childId:int}&{clientId:string}&{oauthProviderError:string}',
                controller: require('./controllers/root.anonymous.box.login'),
                controllerAs: 'loginController',
                templateUrl: 'templates/root.anonymous.box.login.html',
                resolve: {
                redirect: function ($timeout, $state, $stateParams, parent) {
                    if (!parent) {
                        return;
                    }
                    // If already signed in, redirect to the myChildren page before loading the controller, to avoid a flash of the login page first
                    var childParams = {
                        childId: $stateParams.childId,
                        clientId: $stateParams.clientId
                    };
                    // Use $timout to push the state change to the end of the queue so it'll happen after the error is thrown and the route doesn't resolve (otherwise the redirect won't work)
                    $timeout(function () {
                        $state.go('root.authenticated.myChildren', childParams, {reload: true});
                    }, 0);
                    throw new Error('already logged in');
                },
            },
            params: {
              email: null,
              childId: {squash: true},
              clientId: {squash: true},
            },
          });
        }



        // For unmatched routes
        $urlRouterProvider.otherwise('/' + window.helpers.getDeviceLanguage(Object.keys(languages)) + '/login');

        // Enable HTML5
        $locationProvider.html5Mode({
            enabled: true
        });
    }
);

/* @ngInject */ app.config(function (localStorageServiceProvider) {
    localStorageServiceProvider
        .setPrefix('')
        .setStorageType('sessionStorage');
});

// define additional triggers on Tooltip and Popover
/* @ngInject */ app.config(function($uibTooltipProvider) {
    $uibTooltipProvider.setTriggers({
        'open': 'close'
    });
});

/* @ngInject */ app.run(function ($rootScope) {
    // Function wrapper to toggle a popover by id
    $rootScope.openPopoverById = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            var event = new window.Event('open');
            element.dispatchEvent(event);
        }, 0);
    };

    $rootScope.closePopoverById = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            var event = new window.Event('close');
            element.dispatchEvent(event);
        }, 0);
    };
});

/* @ngInject */ app.config(function ($httpProvider) {
    $httpProvider.interceptors.push('ieCacheFix');
});

/* @ngInject */ /*app.config(function ($provide) {
    $provide.decorator('tabsDirective', function($delegate) {
        var directive = $delegate[0];

        directive.templateUrl = 'decorators/tabs.html';

        return $delegate;
    });
});

/* @ngInject */ /*app.config(function ($provide) {
    $provide.decorator('tabDirective', function($delegate) {
        var directive = $delegate[0];

        directive.templateUrl = 'decorators/tab.html';

        return $delegate;
    });
});
*/

/* @ngInject */ app.run(function(gettextCatalog, $rootScope){

    var inProduction = ['production', 'demo'].indexOf(window.config.environment) >= 0;
    gettextCatalog.debug = !inProduction;
    $rootScope.title = gettextCatalog.getString('Parent Portal');

    $rootScope.toggleNavCollapsed = function() {
        $rootScope.navCollapsed = !$rootScope.navCollapsed;
    };

    $rootScope.$on('$stateChangeSuccess', function() {
        // Collapse the main menu on state change success, so it doesn't stay in the way after you press a menu item
        $rootScope.navCollapsed = true;
        // Scroll to top when changing view
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
        console.log('$stateChangeError', toState.name, error);
    });
    $rootScope.$on('$stateChangeStart', function(event, toState){
        console.log('$stateChangeStart', toState.name);
    });
    $rootScope.$on('$stateChangeSuccess', function(event, toState){
        console.log('$stateChangeSuccess', toState.name);
    });
    $rootScope.$on('$stateNotFound', function(event, unfoundState){
        console.log('$stateNotFound', unfoundState.name);
    });
});

/* @ngInject */ app.run(function(uiTourService, $window, $q){
    var tourName = 'intro';
    uiTourService.createDetachedTour(tourName, {
        as: 'ctrl.tour',
        placement: 'left',
        appendToBody: true,
        backdrop: true,
        preventScrolling: true,
        popupClass: 'popover-tour',
        templateUrl: 'templates/popover.tour.html',
        onStart: function () {
            $window.addEventListener('resize', reRenderTour);
            $window.addEventListener('click', tourNextStep);
            return $q.resolve();
        },
        onEnd: function () {
            $window.removeEventListener('resize', reRenderTour);
            $window.removeEventListener('click', tourNextStep);
            return $q.resolve();
        }
    });

    function reRenderTour() {
        var tour = uiTourService.getTour(tourName);
        if( tour && tour.initialized) {
            tour.pause();
            tour.resume();
        }
    }

    function tourNextStep() {
        var tour = uiTourService.getTour(tourName);
        if (!tour || !tour.initialized || !tour._getCurrentStep()) {
            return;
        }

        if(tour._getCurrentStep().isNext) {
            tour.next();
        } else {
            tour.end();
        }
    }
});
